module.exports = __webpack_public_path__ + "static/media/esporte.5fc60acb.svg";